import forOwn from 'mout/object/forOwn'

/**
 * Checks if the node has children.
 * @param {object} node The node to be checked.
 * @returns {boolean} If has children, true, else false.
 */
export default function nodeHasChildrenQ(node) {
  if (node.children) {
    let q = false
    forOwn(node.children, (val) => {
      if (val) {
        q = true
      }
    })
    return q
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/nodeHasChildrenQ.js